import momentTz from 'moment-timezone';
import moment from 'moment';

export const getRemainingDaysToCompleteClaim = (claim, truncate) => {
  if (claim.expiresOn === null) {
    return -1;
  }
  const claimExpiresOn = momentTz(claim.expiresOn).format();
  const now = momentTz().format();
  if (truncate === true) {
    return moment(claimExpiresOn).diff(moment(now), 'days');
  }
  return moment(claimExpiresOn).diff(moment(now), 'days', true);
};
